export default __webpack_public_path__ + "static/media/road-hazard-accident.0a8f121c.svg";